var map = {
	"./amadeus/MasterDetail.json": 1186,
	"./barclays/MasterDetail.json": 1187,
	"./cb911/MasterDetail.json": 1188,
	"./choiceHotels/MasterDetail.json": 1189,
	"./globex/MasterDetail.json": 1190,
	"./kraken/MasterDetail.json": 1191,
	"./lastminute/MasterDetail.json": 1192,
	"./monavate/MasterDetail.json": 1193,
	"./outpayce/MasterDetail.json": 1194,
	"./sofi/MasterDetail.json": 1195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1185;